import React, { useState } from 'react';
import { Menu, X, Briefcase, MapPin, CalendarHeart } from 'lucide-react';
const GOOGLE_MAPS_URL = 'https://maps.app.goo.gl/YkZ8cAkm4wWJcYB3A';
export type ServiceType = 'foretagsbestallning' | 'manadens_meny' | 'catering_event';
interface NavigationProps {
  onOrderClick: (type: ServiceType) => void;
  onJobsClick: () => void;
  onBusinessOrder?: () => void;
  onScrollToCatalog?: () => void;
  onEventsClick?: () => void;
  isEventsActive?: boolean;
}
export function Navigation({
  onOrderClick,
  onJobsClick,
  onBusinessOrder,
  onScrollToCatalog,
  onEventsClick,
  isEventsActive = false
}: NavigationProps) {
  const [isOpen, setIsOpen] = useState(false);
  const handleLinkClick = (type: ServiceType) => {
    if (type === 'foretagsbestallning' && onBusinessOrder) {
      onBusinessOrder();
    } else if (type === 'catering_event' && onScrollToCatalog) {
      onScrollToCatalog();
    } else {
      onOrderClick(type);
    }
    setIsOpen(false);
  };
  const handleJobsClick = () => {
    onJobsClick();
    setIsOpen(false);
  };
  const handleEventsClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onEventsClick?.();
    setIsOpen(false);
  };
  const links: {
    label: string;
    type: ServiceType;
  }[] = [{
    label: 'Företagsbeställning',
    type: 'foretagsbestallning'
  }, {
    label: 'Catering & Event',
    type: 'catering_event'
  }];
  return <nav className="sticky top-0 z-40 w-full bg-[#F2EDE4] border-b border-[#7C8062]/15 shadow-sm" data-id="element-758" data-mp="we1wo4wnbgjm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-759" data-mp="10elsn55hge46">
        <div className="flex justify-center items-center h-12" data-id="element-760" data-mp="156lrsvdqb2zp">
          {/* Desktop Menu - Centered */}
          <div className="hidden md:flex items-center space-x-6 lg:space-x-10" data-id="element-761" data-mp="1a4wzazgjx1er">
            {links.map(link => <button key={link.type} onClick={() => handleLinkClick(link.type)} className="flex items-center gap-1.5 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#7C8062] transition-colors tracking-wide" data-id="element-762" data-mp="1f6mdup2zfx7l">
                {link.label}
              </button>)}
            <a href="/events" onClick={handleEventsClick} aria-current={isEventsActive ? 'page' : undefined} className={`flex items-center gap-1.5 text-sm font-medium transition-colors tracking-wide ${isEventsActive ? 'text-[#7C8062]' : 'text-[#1A1A1A]/70 hover:text-[#7C8062]'}`} data-id="element-763" data-mp="145tlfkqauumb">
              <CalendarHeart className="w-4 h-4" data-id="element-764" data-mp="186lxelqk3dma" />
              Event & Happenings
            </a>
            <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#7C8062] transition-colors tracking-wide" data-id="element-765" data-mp="1n3d0b4zfv7gn">
              <MapPin className="w-4 h-4" data-id="element-766" data-mp="3jxpxleows4jh" />
              Öppettider & Hitta hit
            </a>
            <button onClick={handleJobsClick} className="flex items-center gap-1.5 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#7C8062] transition-colors tracking-wide" data-id="element-767" data-mp="1zeney06p3wm8">
              <Briefcase className="w-4 h-4" data-id="element-768" data-mp="1poaxigu6gjkb" />
              Jobba hos oss
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-2" data-id="element-769" data-mp="1gofi1ztla2eh">
            <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-[#1A1A1A]/70 hover:bg-[#7C8062]/10 focus:outline-none transition-colors" aria-label="Meny" aria-expanded={isOpen} data-id="element-770" data-mp="1gmuoodj0gpi7">
              {isOpen ? <X className="h-5 w-5" data-id="element-771" data-mp="1br5u6olulysr" /> : <Menu className="h-5 w-5" data-id="element-772" data-mp="315kd2sa6qrgc" />}
              <span className="text-sm font-medium tracking-wide" data-id="element-773" data-mp="3633x68tkdyg7">
                {isOpen ? 'Stäng' : 'Meny'}
              </span>
            </button>
          </div>
        </div>
      </div>

      {isOpen && <div className="md:hidden bg-[#F2EDE4] border-t border-[#7C8062]/10 animate-in slide-in-from-top-2 duration-200" data-id="element-774" data-mp="111rnlg9f4hwo">
          <div className="px-4 pt-3 pb-4 space-y-1" data-id="element-775" data-mp="wz3cf1x8eywj">
            <p className="text-xs text-[#1A1A1A]/40 uppercase tracking-wider font-medium px-3 pb-2" data-id="element-776" data-mp="s1lee6kr643b">
              Beställ & Tjänster
            </p>
            {links.map(link => <button key={link.type} onClick={() => handleLinkClick(link.type)} className="flex items-center gap-2 w-full text-left px-3 py-3 rounded-lg text-base font-medium text-[#1A1A1A]/70 hover:bg-[#7C8062]/10 hover:text-[#7C8062] transition-colors" data-id="element-777" data-mp="ibicfgvnlfsu">
                {link.label}
              </button>)}
            <div className="h-px bg-[#7C8062]/10 my-2" data-id="element-778" data-mp="4dtog06ahsjk" />
            <p className="text-xs text-[#1A1A1A]/40 uppercase tracking-wider font-medium px-3 pb-2" data-id="element-779" data-mp="3vj3bpk2wfsph">
              Besök oss
            </p>
            <a href="/events" onClick={handleEventsClick} aria-current={isEventsActive ? 'page' : undefined} className={`flex items-center gap-2 w-full text-left px-3 py-3 rounded-lg text-base font-medium hover:bg-[#7C8062]/10 hover:text-[#7C8062] transition-colors ${isEventsActive ? 'text-[#7C8062]' : 'text-[#1A1A1A]/70'}`} data-id="element-780" data-mp="2b23udlrah0c9">
              <CalendarHeart className="w-5 h-5" data-id="element-781" data-mp="1s7f5e8jxn0iq" />
              Event & Happenings
            </a>
            <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)} className="flex items-center gap-2 w-full text-left px-3 py-3 rounded-lg text-base font-medium text-[#1A1A1A]/70 hover:bg-[#7C8062]/10 hover:text-[#7C8062] transition-colors" data-id="element-782" data-mp="1x6ibzxfk9est">
              <MapPin className="w-5 h-5" data-id="element-783" data-mp="1dj2gtwn6cjy9" />
              Öppettider & Hitta hit
            </a>
            <div className="h-px bg-[#7C8062]/10 my-2" data-id="element-784" data-mp="2gu84znp41r57" />
            <p className="text-xs text-[#1A1A1A]/40 uppercase tracking-wider font-medium px-3 pb-2" data-id="element-785" data-mp="2bwptbpjpkxti">
              Karriär
            </p>
            <button onClick={handleJobsClick} className="flex items-center gap-2 w-full text-left px-3 py-3 rounded-lg text-base font-medium text-[#1A1A1A]/70 hover:bg-[#7C8062]/10 hover:text-[#7C8062] transition-colors" data-id="element-786" data-mp="2qk17lz79yvxb">
              <Briefcase className="w-5 h-5" data-id="element-787" data-mp="1sy3tedzxhcr6" />
              Jobba hos oss
            </button>
          </div>
        </div>}
    </nav>;
}